(function () {
  'use strict';

  function initialize(root) {
    if (root.dataset.mandyInitialized) return;
    root.dataset.mandyInitialized = 'true';

    const updated = root.querySelector('#pubdate');
    if (updated) {
      const date = new Date();
      date.setDate(date.getDate() - 2);
      updated.textContent = 'Updated ' + date.toLocaleDateString('en-US', {
        month: 'long', day: 'numeric', year: 'numeric'
      });
    }

    const parameters = new URLSearchParams(window.location.search);
    root.querySelectorAll('a[data-cta]').forEach(function (link) {
      const destination = new URL(link.getAttribute('href'), window.location.origin);
      parameters.forEach(function (value, key) {
        if (/^utm_/i.test(key) || key === 'fbclid') destination.searchParams.set(key, value);
      });
      link.href = destination.pathname + destination.search + destination.hash;
    });

    const sticky = root.querySelector('#sticky');
    const final = root.querySelector('.final');
    const reveal = root.querySelector('#reveal');
    if (!sticky || !final || !reveal) return;

    const controller = new AbortController();
    function updateSticky() {
      const finalBounds = final.getBoundingClientRect();
      const finalVisible = finalBounds.top < window.innerHeight && finalBounds.bottom > 0;
      const pageEndVisible = root.getBoundingClientRect().bottom <= window.innerHeight;
      const visible = reveal.getBoundingClientRect().bottom < window.innerHeight && !finalVisible && !pageEndVisible;
      sticky.classList.toggle('on', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
      sticky.toggleAttribute('inert', !visible);
    }
    window.addEventListener('scroll', updateSticky, { passive: true, signal: controller.signal });
    window.addEventListener('resize', updateSticky, { passive: true, signal: controller.signal });
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(root)) controller.abort();
    }, { signal: controller.signal });
    updateSticky();
  }

  document.querySelectorAll('.clc-mandy').forEach(initialize);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.clc-mandy').forEach(initialize);
  });
}());
